/************************************************************************************

* [COMPONENT]: PRODUCT PAGE - BLOCK VARIANT RESET INFO

*************************************************************************************/

if (!customElements.get('l-product-variants-reset-info')) {
	class LTAProductVariantsResetInfo extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			// Data
			this.sectionId = this.dataset.sectionId

			// Events
			document.addEventListener('l:variant:changed', () => {
				this.productSelectIdEl = this.productSelectIdEl || document.getElementById(`ProductSelect-${this.sectionId}`)
				this.variantContentEls = this.variantContentEls || this.querySelectorAll('[data-variant]')

				if (!this.productSelectIdEl) return

				const selectedVariantId = this.productSelectIdEl.value

				this.variantContentEls.forEach((el) => {
					el.classList.toggle('hidden', el.dataset.variant != selectedVariantId)
				})
			})
		}
	}

	customElements.define('l-product-variants-reset-info', LTAProductVariantsResetInfo)
}


document.addEventListener('DOMContentLoaded', function () {
	var slideMenuCarts = document.querySelectorAll('.slide-menu-cart')

	slideMenuCarts.forEach(function (slideMenuCart) {
		slideMenuCart.addEventListener('click', function (e) {
			e.preventDefault()
			Rebuy.SmartCart.show()
			window.setTimeout(function () {
				custom_closecartdrawer()
			}, 500)
		})
	})

	/*
  $('body').on('click', '.slide-menu-cart', function(e){
    e.preventDefault();
      Rebuy.SmartCart.show();
      window.setTimeout(function(){
        custom_closecartdrawer();
      }, 500);
  });
  */
})

document.addEventListener('DOMContentLoaded', function () {
  const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
  const submitAction = document.querySelector('.product-page--submit-action') || document.querySelector('.gf_add-to-cart.product-form-product-template');

  if (!stickyAddToCart || !submitAction) return;

  const btnLinkJsEl = stickyAddToCart.querySelector('.btn.secondary-button')
  if (btnLinkJsEl) {
    btnLinkJsEl.addEventListener('click', function (e) {
      e.preventDefault();

      submitAction.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    })
  }

  window.addEventListener('scroll', function () {
    const stickyHeader = document.querySelector('.sticky-header-wrapper.sticky');

    console.log(stickyAddToCart);
    console.log(stickyHeader);
    console.log(submitAction);

    if (!stickyAddToCart || !stickyHeader || !submitAction) return;

    const headerHeight = stickyHeader.offsetHeight;
    stickyAddToCart.style.top = headerHeight + 1 + 'px';

    const submitActionTop = submitAction.getBoundingClientRect().top + window.scrollY;
    const isActive = window.scrollY > submitActionTop;

    stickyAddToCart.classList.toggle('active', isActive);
    document.body.classList.toggle('satc-active', isActive);
  });
})

jQuery(function () {
	$('.single-option-selector').on('change', function () {
		setTimeout(function () {
			if ($('[name="id"]').val() != '{{ product.selected_or_first_available_variant.id }}') {
				location.reload()
			}
		}, 1)
	})

	// Owl RESET Variant Change: 18th Jan 2024
	$(document).change('[name="option-0"]', function () {
		let variantId = $('[name="id"]').val()
		if (
			typeof item === 'object' &&
			item !== null &&
			item.hasOwnProperty('ProductID') &&
			typeof smartrrProductList === 'object'
		) {
			var smartrrProduct = smartrrProductList[item.ProductID]
			if (smartrrProduct) {
				smartrrProduct.ui.logic.apiChangeVariant(variantId)
			}
		}
	})
})

// $('body').on('click', '.slide-menu-cart', function(e){
//     e.preventDefault();
//       Rebuy.SmartCart.show();
//       window.setTimeout(function(){
//         custom_closecartdrawer();
//       }, 500);
//   });

$('body').on('click', '.slide-menu-cart', function () {
	console.log('test')
})

function custom_closecartdrawer() {
	jQuery('#slideout-overlay').hide()
	jQuery('.slideout-menu').addClass('slideout-panel-hidden')
	jQuery('.slideout-panel-right').attr('style', '')
}

jQuery(function () {
	$('body').on('click', '.satc__button .btn', function () {
		$('button#purchase').trigger('click')
	})
	if ($('.smartrr-purchase-options').length > 0) {
		setTimeout(function () {
			var v = $('[name="purchase_option"]:checked').val()
			if (v == '') {
				$('.satc__variant span:last-child').text('delivered one time')
				$('.satc__price').html($('[data-smartrr-subscribe-price]').text())
			} else {
				var opt = $('.smartrr-plan-active').val()
				var opt_name = $('.smartrr-plan-active [value="' + opt + '"]').text()
				$('.satc__variant span:last-child').text('delivered every ' + opt_name)
				$('.satc__price').html($('[data-smartrr-subscribe-price]').text())
			}
			$('[name="purchase_option"]').change(function () {
				if ($(this).val() == '') {
					$('.satc__variant span:last-child').text('delivered one time')
					$('.satc__price').html($('[data-smartrr-subscribe-price]').text())
				} else {
					var opt = $('.smartrr-plan-active').val()
					var opt_name = $('.smartrr-plan-active [value="' + opt + '"]').text()
					$('.satc__variant span:last-child').text('delivered every ' + opt_name)
					$('.satc__price').html($('[data-smartrr-subscribe-price]').text())
				}
			})
		}, 500)
	}
})